// extracted by mini-css-extract-plugin
export var statItem = "_c3-1";
export var statsRow = "_c3-0";